module.exports = __webpack_public_path__ + "img/RWBuild Summit Advertising Graphic.b279e4b7.png";